<template>
    <div>
        <v-card flat color="lightgray">
            <v-card-text class="text-body-1">
                {{$T('stock-quantities')}}
				{{ $T('sort-by') }} : 
                <v-radio-group
					v-model="sort"
					row
					hide-details
				>
					<v-radio
						:label="$T('inputs.name')"
						:value="0"
						class="mx-auto"
						color="success"
					/>
					<v-radio
						:label="$T('inputs.quantity')"
						:value="1"
						class="mx-auto"
						color="success"
					/>
				</v-radio-group>
            </v-card-text>
        </v-card>

        <v-container>
			<!-- {{ sortedTransactions }} -->
            <div v-if="!loading && sortedTransactions.length > 0">
                <v-row class="mx-auto mb-0" style="width: 95%">
                    <v-col cols="9">
                        <v-icon small class="primary--text text--lighten-2 me-1">mdi-pill</v-icon>
                        <span class="text-capitalize primary--text text--darken-1">{{$T('sample-name')}}</span>
                    </v-col>
                    <v-col cols="3" class="text-center">{{$T('remaining')}}</v-col>
                </v-row>
                <sample-card
                  v-for="transaction in sortedTransactions"
                  :key="`${transaction.materialId}-${sort}`"
                  :sample="transaction"
                  class="mb-2"
                  @on-swipe="fetchVisit()"
                />
            </div>

            <div
              v-else-if="!loading && sortedTransactions.length === 0"
              class="d-flex flex-column justify-center align-center"
              style="height: 65vh"
            >
                <v-icon x-large class="mb-3">mdi-pill</v-icon>
                <span class="grey--text text--darken-2">{{$T('no-samples-to-show')}}</span>
            </div>
        </v-container>

        <loader v-if="loading"/>
    </div>
</template>

<script>
import SampleCard from '../components/SampleCard'
import Loader from '../components/Loader'
import { mapState } from 'vuex'
export default {
	name: 'Samples',

	data() {
		return {
			loading: true,
			sort: 1,
			sortedTransactions: [],
		}
	},
	
	watch: {
		transactions() {
			this.sortTransactions();
		},
		sort() {
			console.log('sort')
			this.sortTransactions();
		}
	},

	components: {
		Loader,
		SampleCard,
	},

	mounted() {
		this.loading = true;
		Promise.all([
			this.$store.dispatch('materialsTransactions/fetchAll'),
			this.$store.dispatch('materialForms/fetchAll'),
			this.$store.dispatch('materials/fetchAll', { name: null, materialFormId: null })
		])
			.finally(() => {
				this.loading = false;
			})
	},

	computed: {
		...mapState({
			transactions: state => state.materialsTransactions.transactions
		})
	},

	methods: {
		sortTransactions() {
			const transactions = [...this.transactions];
			if (this.sort === 0) {
				this.sortedTransactions = transactions.sort((a, b) => {
					if (!a.material || !a.material.name) return 1;
					if (!b.material || !b.material.name) return -1;
					return a.material.name.localeCompare(b.material.name)
				});
			} else {
				console.log('transactions', transactions.map(c => c.remaining))
				if (this.transactions.length) {
					this.sortedTransactions = transactions?.sort((a, b) => b.remaining.amount - a.remaining.amount);
				}
			}
		}
	},

	beforeDestroy() {
		this.$store.dispatch('materialsTransactions/reset');
		this.$store.dispatch('materialForms/reset');
		this.$store.dispatch('materials/reset');
	}
}
</script>

<style>

</style>